// extracted by mini-css-extract-plugin
export default {"box":"FTFCBoxes_box__fpMFK","container":"FTFCBoxes_container__Q03HO"};